import { zonedDateTimeToUtc } from "../supabase/functions/date-notifications/calendar";

export type BookedPlanLike = {
  id: string;
  proposedDate: string;
  reservationTime?: string | null;
  timeZone?: string | null;
  stage: string;
};

export function bookingInstant(plan: BookedPlanLike) {
  const time = plan.reservationTime || "23:59:59";
  if (plan.timeZone) return zonedDateTimeToUtc(plan.proposedDate, time, plan.timeZone);
  return new Date(`${plan.proposedDate}T${time}`);
}

export function splitBookedPlans<T extends BookedPlanLike>(plans: T[], now = new Date()) {
  const booked = plans
    .filter((plan) => plan.stage === "booked")
    .map((plan) => ({ plan, instant: bookingInstant(plan).getTime() }))
    .filter(({ instant }) => Number.isFinite(instant));

  return {
    future: booked
      .filter(({ instant }) => instant >= now.getTime())
      .sort((a, b) => a.instant - b.instant || a.plan.id.localeCompare(b.plan.id))
      .map(({ plan }) => plan),
    overdue: booked
      .filter(({ instant }) => instant < now.getTime())
      .sort((a, b) => b.instant - a.instant || a.plan.id.localeCompare(b.plan.id))
      .map(({ plan }) => plan),
  };
}
